import DataTableHeading from '@/util/DataTableHeading';
import { useAppSelector } from '@/store/hooks';
import {
  selectIsLoadingColumns,
  selectIsLoadingRows,
} from '@/features/query-builder/queryBuilderSlice';
import { useLoadColumns_LEGACY } from './useLoadColumns_LEGACY';
import { useLoadRows_LEGACY } from './useLoadRows_LEGACY';

export const useHeadings_LEGACY = () => {
  const isLoadingColumns = useAppSelector(selectIsLoadingColumns);
  const isLoadingRows = useAppSelector(selectIsLoadingRows);
  const { headings, isSuccess } = useLoadColumns_LEGACY();
  const { dataTable } = useLoadRows_LEGACY(!isSuccess || isLoadingColumns);

  if (isLoadingColumns) return null;

  if (isLoadingRows) return headings?.map(DataTableHeading.fromColumn);

  return dataTable?.headings();
};
